import React, {useState} from "react";
import {Button, Container, Dropdown, Icon, Image, Menu, Segment} from "semantic-ui-react";
import SearchBar from './SearchBar';
import "../../css/Header.css";
import {NavLink, useNavigate} from "react-router-dom";
import {getUsername, LogoutLink, useAuth} from "../auth";

const Nav = props => {
    return (
        <NavLink {...props}/>
    );
};

const SeniorViewBanner = ({onExit, loading}) => (
    <div className="senior-view-banner" role="status">
        <span>
            Viewing the system as a Senior (foreman). Writes are disabled.
        </span>
        <Button
            size="mini"
            inverted
            onClick={onExit}
            loading={loading}
            disabled={loading}
        >
            Exit Senior view
        </Button>
    </div>
);

export const Header = () => {
  const imageUrl = "/img/tds.png";
  const auth = useAuth();
  const navigate = useNavigate();
  const [toggling, setToggling] = useState(false);
  const canToggle = auth.canUseSeniorView;
  const inSeniorView = auth.seniorView;
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);

  const toggleSeniorView = async (enabled) => {
    setToggling(true);
    try {
      await auth.setSeniorView(enabled);
      navigate('/');
    } catch (error) {
      console.error("Failed to toggle Senior view:", error);
    } finally {
      setToggling(false);
    }
  };

  return (
    <div className={inSeniorView ? 'has-senior-view-banner' : ''}>
      <Segment id="header-segment" attached>
        <Container id="header-container">
            <Menu id="nav-item" size='large' fixed='top' borderless>
                <Menu.Item as={Nav} to='/' header>
                    <Image size='mini' src={imageUrl} style={{marginRight: '.5em'}}/>
                    <span id='header-app-name'>ICC Tool</span>
                </Menu.Item>
                <Menu.Menu position='right'>
                    <Menu.Item id='header-search-desktop'>
                        <div id='header-search-wrap'>
                            <SearchBar />
                        </div>
                    </Menu.Item>
                    <Menu.Item
                        id='header-search-mobile-trigger'
                        onClick={() => setMobileSearchOpen(v => !v)}
                    >
                        <Icon name={mobileSearchOpen ? 'close' : 'search'}/>
                    </Menu.Item>
                    <Dropdown item trigger={<span><Icon name='user'/> {getUsername()}</span>}>
                        <Dropdown.Menu>
                            {canToggle && !inSeniorView && (
                                <Dropdown.Item
                                    onClick={() => toggleSeniorView(true)}
                                    disabled={toggling}
                                >
                                    View as Senior
                                </Dropdown.Item>
                            )}
                            {canToggle && inSeniorView && (
                                <Dropdown.Item
                                    onClick={() => toggleSeniorView(false)}
                                    disabled={toggling}
                                >
                                    Exit Senior view
                                </Dropdown.Item>
                            )}
                            <LogoutLink/>
                            <Dropdown.Item as={Nav} to={'/password-change'}>Change Password</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </Menu.Menu>
            </Menu>
            {inSeniorView && (
                <>
                    <SeniorViewBanner
                        onExit={() => toggleSeniorView(false)}
                        loading={toggling}
                    />
                    <div className="senior-view-banner-spacer" />
                </>
            )}
            {mobileSearchOpen && (
                <div id='header-search-mobile-panel'>
                    <SearchBar />
                </div>
            )}
        </Container>
      </Segment>
    </div>
  );
};
